module.exports = __webpack_public_path__ + "static/media/999.27f520e6.svg";